import {useQuery} from 'react-query'
import {getRewardNotifications} from 'api'
import {getItemFromStorage} from 'utils/storage'

/**
 * The signed-in member's pending "You earned N Sharpennies!" popups, as
 * one shared react-query entry.
 *
 * RewardNotificationsModal used to fetch these itself, once on mount,
 * so coins earned by commenting or posting only announced themselves
 * on the next page navigation or reload — on a phone, where members
 * stay on the feed, that read as "no coins". Everything that can earn
 * coins now invalidates this key (see useInvalidateRewardState) and the
 * modal reacts to the refetch, so the popup lands in place.
 */
export const REWARD_NOTIFICATIONS_QUERY_KEY = 'rewardNotifications'

const useRewardNotifications = () => {
  const user = getItemFromStorage({name: 'user'})
  return useQuery(REWARD_NOTIFICATIONS_QUERY_KEY, getRewardNotifications, {
    enabled: !!user?.id,
    // Pending popups are consumed as they show, so a cached list is
    // never worth keeping: every mount and every invalidate refetches.
    staleTime: 0,
    // The award is fire-and-forget on the backend; a refetch that races
    // it simply comes back empty and the settle refetch catches it.
    retry: false,
  })
}

export default useRewardNotifications
